import { useEffect } from "react";
import { useParams, Outlet, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SUPPORTED = ["nl", "en", "hu"];

/**
 * Route wrapper that syncs the URL /:lang segment to i18n + <html lang>.
 * Also injects hreflang alternates. Redirects unknown language segments to /.
 */
export default function LangRouteWrapper({ defaultLng = "nl" }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const isValid = SUPPORTED.includes(lang);

  useEffect(() => {
    if (!isValid) return;
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.setAttribute("lang", lang);

    // Inject / refresh hreflang tags for SEO
    const existing = document.querySelectorAll('link[rel="alternate"][data-i18n-hreflang]');
    existing.forEach((n) => n.remove());
    const origin = window.location.origin;
    const rest = window.location.pathname.replace(/^\/(nl|en|hu)(?=\/|$)/, "") || "";
    SUPPORTED.forEach((code) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = code;
      link.href = `${origin}/${code}${rest}`;
      link.setAttribute("data-i18n-hreflang", "true");
      document.head.appendChild(link);
    });
    const xd = document.createElement("link");
    xd.rel = "alternate";
    xd.hreflang = "x-default";
    xd.href = `${origin}/nl${rest}`;
    xd.setAttribute("data-i18n-hreflang", "true");
    document.head.appendChild(xd);
  }, [isValid, lang, i18n]);

  if (!isValid) return <Navigate to="/" replace />;

  return <Outlet />;
}
